// extracted by mini-css-extract-plugin
export var container = "_4c-0";
export var fallback = "_4c-5";
export var fallbackIcon = "_4c-6";
export var hidden = "_4c-2";
export var image = "_4c-3";
export var loaded = "_4c-4";
export var placeholder = "_4c-1";